import styled, { css } from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../tokens'

export const Field = styled.div`
  ${fontScope}
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const Label = styled.label<{ $dense: boolean }>`
  ${fieldLabel}
  white-space: nowrap;
  ${({ $dense }) =>
    $dense &&
    css`
      line-height: normal;
      letter-spacing: 0;
    `}
`

export const Trigger = styled.button<{ $placeholder: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  padding: 10px 32px 10px 16px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.input};
  background: ${colors.white};
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${({ $placeholder }) => ($placeholder ? colors.ink500 : colors.ink950)};
  cursor: pointer;

  &:focus-visible,
  &[aria-expanded='true'] {
    border-color: ${colors.ink400};
  }
`

export const Summary = styled.span`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const Chevron = styled.img<{ $open: boolean }>`
  position: absolute;
  right: 8px;
  pointer-events: none;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`

export const Popover = styled.div<{ $align: 'start' | 'end', $inline: boolean }>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid ${colors.border};
  border-radius: ${radius.input};
  background: ${colors.white};
  outline: none;
  ${({ $inline, $align }) =>
    $inline
      ? css`
          width: 100%;
        `
      : css`
          position: absolute;
          top: calc(100% + 4px);
          ${$align === 'end' ? 'right: 0;' : 'left: 0;'}
          z-index: 30;
          width: max(100%, 260px);
          max-width: calc(100vw - 32px);
          box-shadow: 0 8px 24px rgba(10, 10, 10, 0.12);
        `}
`

export const Search = styled.input`
  margin: 8px 8px 0;
  padding: 8px 12px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.input};
  outline: none;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.ink950};

  &::placeholder {
    color: ${colors.ink500};
  }

  &:focus-visible {
    border-color: ${colors.ink400};
  }
`

export const List = styled.ul`
  max-height: 280px;
  margin: 0;
  padding: 4px 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  list-style: none;
`

export const AllItem = styled.li`
  border-bottom: 1px solid ${colors.rowDivider};
`

export const OptionLabel = styled.label<{ $disabled: boolean }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ $disabled }) => ($disabled ? 'transparent' : colors.accent)};
  }
`

export const OptionText = styled.span<{ $strong?: boolean }>`
  min-width: 0;
  font-size: 14px;
  font-weight: ${({ $strong }) => ($strong ? 600 : 400)};
  line-height: 18px;
  color: ${colors.ink800};
  overflow-wrap: anywhere;
`

export const Note = styled.p`
  margin: 0;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.ink500};
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border-top: 1px solid ${colors.border};
`

export const Count = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.ink500};
`

export const ApplyButton = styled.button`
  padding: 6px 14px;
  border: 0.8px solid ${colors.primary};
  border-radius: 6px;
  background: ${colors.primary};
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: ${colors.white};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`
